/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react'

import { mpfWhoHttp } from '../../../assets/ts/api/mpf-who-http'
import { COMPONENTS_CODE } from '../../../assets/ts/data/common-metadata'
import { Inquiry } from '../../../assets/ts/data/inquiry/inquiry'
import { PascodeMetadata } from '../../../assets/ts/data/pascode-metadata'
import {
  filterRank,
  formatPhoneNumber,
  getMAJCOMCode,
  getUserProfileWithoutID,
} from '../../../assets/ts/general/general'
import { MetadataContext } from '../../../store/metadata-context-provider'
import { UserContext } from '../../../store/user-context-provider'
import {
  MAX_LENGTHS,
  SELECT_OPTION,
  SELECT_OPTION_STRING,
} from '../../../utils/constants/global-constants'
import CustomSelect from '../../../utils/controls/custom-select'
import InputCheckbox from '../../../utils/controls/input-checkbox'
import InputText from '../../../utils/controls/input-text'
import ProfileOrganizationDetails from '../../profile/profile-organization-details'

const initialPASCODECheck = {
  HasLocation: false,
  HasOrganization: false,
  HasPASCODE: 'Yes',
}

const CustomerDetails = ({
  changeInquiryType,
  currentUserObj,
  dodPopulated,
  dutyMailDisable,
  initialUserInputs,
  inputValidationObj,
  inquiryForSelf,
  isInquiryEditing,
  pascodeChecks,
  pascodeMetadata,
  selectedUserEmail,
  selfForOther,
  setDodPopulated,
  setDutyMailDisable,
  setIsValid,
  setPascodeChecks,
  setProfileLoaded,
  setSelectedUserEmail,
  setSelfForOther,
  setShowReadonlyInput,
  setShowSubmit,
  setShowTopSubmit,
  setUniqueChange,
  setUserInputs,
  showReadonlyInput,
  userInputs,
}) => {
  const { me } = useContext(UserContext)

  const { majcoms, ranks, tooltipObj } = useContext(MetadataContext)

  const currentUserEmail = currentUserObj.DutyEmail

  const metadataContext = useContext(MetadataContext)
  const [peopleDropdownNames, setPeopleDropdownNames] = useState<string[]>([])
  const [organizationPASCODE, setOrganizationPASCODE] = useState<PascodeMetadata[]>()
  const [pascodeDDL, setPascodeDDL] = useState<string[]>([])
  const [isRegAF, setIsRegAF] = useState(true)
  const [assignedLocationDDL, setAssignedLocationDDL] = useState<string[]>([])
  const [organizationDDL, setOrganizationDDL] = useState<string[]>([])
  const [existingUser, setExistingUser] = useState<any>({})
  const [statusOptions, setStatusOptions] = useState([SELECT_OPTION_STRING])
  const [rankOptions, setRankOptions] = useState([SELECT_OPTION_STRING])

  const assignedComponentOptions = [
    ...metadataContext.components.map((component) => ({
      label: component.Component,
      value: component.ComponentCode,
    })),
  ]

  const generateStatusOption = (assignComponentCode: number) => {
    const profileStatus = [
      ...new Set(
        ranks
          ?.filter((assCom) => assCom.AssignedComponentCode === assignComponentCode)
          .map(({ Status }) => {
            return Status
          })
      ),
    ].map((rank) => {
      return { label: rank, value: rank }
    })
    setStatusOptions([SELECT_OPTION_STRING, ...profileStatus])
  }

  const handleChangeNumber = (e: any) => {
    const numbersOnly = (value: string, target: string) => {
      const numbersOnly = /^[0-9\b]+$/
      const numbersWithSymbolsAndSpace = /^[0-9()\b\s-]+$/
      if (value === '' || (numbersOnly.test(value) && value.length < 11)) {
        setUserInputs({ ...userInputs, [target]: value })
      }
      if (numbersWithSymbolsAndSpace.test(value) && value.length === 13) {
        const output = value.slice(0, -1).replace(/[^\d]/g, '')
        setUserInputs({ ...userInputs, [target]: output })
      }
    }
    numbersOnly(e.target.value, e.target.id)
  }

  const handleChangeDoDNumber = async (e: any) => {
    const { id, value } = e.target

    const numberReg = /^[0-9\b]+$/
    if (value === '' || numberReg.test(value)) {
      setShowReadonlyInput(false)
      setPascodeChecks({
        ...pascodeChecks,
        HasLocation: false,
        HasOrganization: false,
        HasPASCODE: pascodeChecks.HasPASCODE,
      })
      setUserInputs((prevUserInputs) => ({
        ...initialUserInputs,
        [id]: value,
      }))
    }

    if (value.length === 10) {
      try {
        // Try fetching the existing profile
        const existingProfile: any = await getUserProfileWithoutID(value, 'DoDNumber')

        let newProfile: any = []
        try {
          // Attempt to fetch new profile
          newProfile = await mpfWhoHttp().Other(value.trim())
        } catch (err) {
          newProfile = [{}]
        }
        // Check if existingProfile is empty, then use newProfile as fallback
        const profile = Object.keys(existingProfile).length === 0 ? newProfile[0] : existingProfile

        const profileNumber = existingProfile.DoDNumber
          ? existingProfile.DoDNumber
          : newProfile[0]?.edipi || ''

        const currentUserDod = currentUserObj.DoDNumber ? currentUserObj.DoDNumber : null

        if (
          profileNumber &&
          currentUserDod &&
          ((!inquiryForSelf && profileNumber !== currentUserDod) ||
            (inquiryForSelf && profileNumber === currentUserDod))
        ) {
          const emailIsChanged = existingProfile.DutyEmail &&
            newProfile[0].email !== existingProfile.DutyEmail
          emailIsChanged && setUniqueChange('Duty Email has recently changed.')
          const updatedUserInputs: Partial<Inquiry> = {
            AssignedComponentCode: profile.AssignedComponentCode ?? 143,
            Customer: profile.UserRID ?? profile.rid ?? '',
            CustomerStatus: profile.CustomerStatus ?? '',
            DoDNumber: profile.DoDNumber ?? profile.edipi ?? '',
            DutyEmail: emailIsChanged? newProfile[0].email : profile.DutyEmail ?? profile.email ?? '',
            DutyPhone: profile.DutyPhone ?? '',
            Installation: profile.Installation ?? '',
            OrgMAJCOM: profile.OrgMAJCOM ?? '',
            Organization: profile.Organization ?? '',
            PASCODE: profile.PASCODE ?? profile.pascode ?? '',
            PASCODEServicedBy: profile.PASCODEServicedBy ?? '',
            PascodeID: profile.PascodeID ?? profile.PascodeID ?? '',
            PersonalEmail: profile.PersonalEmail ?? '',
            PersonalPhoneNumber: profile.PersonalPhone ?? '',
            PersonalPhoneProvider: profile.PersonalPhoneProvider ?? '',
            Rank: profile.Rank ?? profile.rank ?? '',
            ServicingMAJCOMCode: getMAJCOMCode(profile.ServicingMAJCOM, majcoms),
            ServicingOrganization: profile.ServicingOrganization ?? '',
          }

          setUserInputs((prevUserInputs) => ({
            ...prevUserInputs,
              ...updatedUserInputs,
          }))
          
        } else if (!inquiryForSelf && profileNumber === currentUserDod) {
          // Sets error when entering self DoD ID for "Other"
          setSelfForOther({ ...selfForOther, DoDForOther: { isValid: false } })
          setUserInputs((prevUserInputs) => ({
            ...prevUserInputs,
            DoDNumber: '',
          }))
          setShowSubmit(true)
          setIsValid(false)
        } else if (
          inquiryForSelf &&
          Object.keys(profile).length > 0 &&
          profileNumber !== currentUserDod
        ) {
          setSelfForOther({ ...selfForOther, DoDNumberSelf: { isValid: false } })
          setUserInputs((prevUserInputs) => ({
            ...prevUserInputs,
            DoDNumber: '',
          }))
          setShowSubmit(true)
        }
      } catch (err) {
        console.error('Error in handleChangeDoDNumber:', err)
      }
    } else if (value.length === 9) {
      setShowTopSubmit(false)
      setShowSubmit(false)
      setDutyMailDisable(false)
      setSelfForOther({
        ...selfForOther,
        EmailForOther: { isValid: true },
      })
    }
  }

  const handleAssignedComponentChange = (e) => {
    generateStatusOption(e.value)
    setRankOptions([SELECT_OPTION_STRING])
    setShowReadonlyInput(false)
    setUserInputs((prevUserInputs) => ({
      ...prevUserInputs,
      AssignedComponentCode: e.value,
      CustomerStatus: '',
      Installation: '',
      OrgMAJCOM: '',
      Organization: '',
      PASCODE: '',
      PASCODEServicedBy: '',
      Rank: '',
      ServicingMAJCOMCode: '',
      ServicingOrganization: '',
    }))
    setPascodeChecks({
      ...pascodeChecks,
      HasLocation: false,
      HasOrganization: false,
      HasPASCODE: pascodeChecks.HasPASCODE,
    })
  }

  const selectedEmail = async (value: string, inquiryForSelf: boolean) => {
    setDodPopulated(false)

    //find user dod based on email provided with out a user profile
    const user = await mpfWhoHttp().Picker(value)
    const userDOD = user[0].edipi
    if (inquiryForSelf) {
      setUserInputs((prev) => ({
        ...prev,
        DoDNumber: userDOD,
        DutyEmail: value,
      }))
    } else if (!inquiryForSelf) {
      if (value === me.email) {
        setDodPopulated(false)
        setShowTopSubmit(true)
        setIsValid(false)
        setUserInputs((prev) => ({
          ...prev,
          DoDNumber: '',
          DutyEmail: value,
        }))
      } else {
        setDodPopulated(true)
        setUserInputs((prev) => ({
          ...prev,
          DoDNumber: userDOD,
          DutyEmail: value,
        }))
      }
    }
    setSelectedUserEmail(value)
  }

  const handleEmailChange = async (e: any) => {
    setShowTopSubmit(false)
    setProfileLoaded(false)
    setDodPopulated(false)
    setShowReadonlyInput(false)
    setSelectedUserEmail('')
    setUserInputs((prevUserInputs) => ({
      ...initialUserInputs,
    }))
    setPascodeChecks({
      ...pascodeChecks,
      HasLocation: false,
      HasOrganization: false,
      HasPASCODE: pascodeChecks.HasPASCODE,
    })
    const { value } = e.target
    checkForOnlySpaces(value)
      ? setUserInputs((prevUserInputs) => ({
          ...prevUserInputs,
          DutyEmail: '',
        }))
      : setUserInputs((prevUserInputs) => ({
          ...prevUserInputs,
          [e.target.id]: e.target.value,
        }))
    setSelfForOther({
      ...selfForOther,
      DoDForOther: { isValid: true },
      DoDNumberSelf: { isValid: true },
      EmailChange: { isValid: true },
      EmailForOther: { isValid: true },
    })

    if (value.length > 2) {
      //this area creates email dropdown slections
      const userList: any = [...(await mpfWhoHttp().Picker(value.trim()))]
      const userName = await userList.map((item) => item.email)
      setPeopleDropdownNames(userName)
    }
  }

  const checkForOnlySpaces = (val) => /^\s*$/.test(val)

  const handleUserStatusChange = (e) => {
    const value = e.value
    const filteredGrades = filterRank(e.value, ranks, userInputs.AssignedComponentCode)
    const rankOptions =
      filteredGrades.length === 1 ? filteredGrades : [SELECT_OPTION_STRING, ...filteredGrades]
    setRankOptions(rankOptions)
    setUserInputs({
      ...userInputs,
      CustomerStatus: value,
      Rank: filteredGrades.length === 1 ? rankOptions[0].value : '',
    })
  }
  const handleRankChange = (e) => {
    const value = e.value
    setUserInputs((prevUserInputs) => ({ ...prevUserInputs, Rank: value }))
  }

  useEffect(() => {
    if (userInputs?.AssignedComponentCode !== -1) {
      generateStatusOption(userInputs?.AssignedComponentCode)
      const filteredGrades = filterRank(
        userInputs.CustomerStatus,
        ranks,
        userInputs.AssignedComponentCode
      )
      const rankOptions =
        filteredGrades.length === 1 ? filteredGrades : [SELECT_OPTION_STRING, ...filteredGrades]
      setRankOptions(rankOptions)
    }
  }, [ranks, userInputs])

  //updates user inputs based on the user's selection from email dropdown
  useEffect(() => {
    const updateUserInputs = async () => {
      if (selectedUserEmail === '') return
      // Set up to prepopulate the field based on email that's selected, other than for self
      let profile: any = await getUserProfileWithoutID(selectedUserEmail, 'DutyEmail')
      
      if (Object.values(profile).length === 0) {
        profile = await getUserProfileWithoutID(userInputs.DoDNumber, 'DoDNumber')
        if (profile.DutyEmail && profile.DutyEmail !== selectedUserEmail) {
          profile.DutyEmail = selectedUserEmail
          setUniqueChange('Duty Email has recently changed.') // Sets error message for email change
        }
      }
      const profileEmail = profile.DutyEmail ? profile.DutyEmail : null
      setExistingUser(profile)
      if (
        // profileEmail &&
        currentUserEmail &&
        ((!inquiryForSelf && profileEmail !== currentUserEmail) ||
          (inquiryForSelf && profileEmail === currentUserEmail))
      ) {
        setUserInputs((prevUserInputs) => ({
          ...prevUserInputs,
          ...profile,
          Customer: profile.UserRID,
          ServicingMAJCOMCode: profile.ServicingMAJCOMCode,
        }))
        setProfileLoaded(true)
        setPascodeChecks({
          HasLocation: true,
          HasOrganization: true,
          HasPASCODE: 'Yes',
        })
        setShowReadonlyInput(true)
        if (!profileEmail) {
          setShowReadonlyInput(false)
        } //resets readonly input if email does not have profile
      }
    }

    updateUserInputs()
  }, [selectedUserEmail, inquiryForSelf, currentUserObj])

  useEffect(() => {
    if (!inquiryForSelf && selectedUserEmail === currentUserEmail) {
      setSelfForOther((prev) => ({
        ...prev,
        EmailForOther: { isValid: false },
      }))
      setUserInputs((prevUserInputs) => ({ ...prevUserInputs, DutyEmail: '' }))
      setSelectedUserEmail('') // Reset the selectedUserEmail after validation
      setShowSubmit(true)
    }
  }, [inquiryForSelf, selectedUserEmail, currentUserObj, dodPopulated])

  useEffect(() => {
    const orgPASCODE = pascodeMetadata.filter(
      (item) =>
        userInputs?.AssignedComponentCode === -1 ||
        userInputs?.AssignedComponentCode === null ||
        item.AssignedComponentCode === userInputs?.AssignedComponentCode
    )
    if (userInputs?.AssignedComponentCode === COMPONENTS_CODE.Regular_Air_Force) {
      setIsRegAF(true)
    } else {
      setIsRegAF(false)
    }
    setOrganizationPASCODE(orgPASCODE)
  }, [pascodeMetadata, userInputs?.AssignedComponentCode])

  useEffect(() => {
    const assignedlocations = organizationPASCODE
      ? [
          ...new Set(
            organizationPASCODE.map(({ Installation }) => {
              return Installation
            })
          ),
        ].filter((item) => item !== undefined)
      : []
    const organizations = organizationPASCODE
      ? [
          ...new Set(
            organizationPASCODE.map(({ Organization }) => {
              return Organization
            })
          ),
        ].filter((item) => item !== undefined)
      : []
    const pascodes = organizationPASCODE
      ? [
          ...new Set(
            organizationPASCODE.map(({ PASCODE }) => {
              return PASCODE
            })
          ),
        ].filter((item) => item !== undefined)
      : []
    setAssignedLocationDDL(assignedlocations)
    setOrganizationDDL(organizations)
    setPascodeDDL(pascodes)
  }, [organizationPASCODE])

  return (
    <>
      <div className='row'>
        <div className='mb-1 col-xl-12 col-lg-12 col-md-12 col-sm-12 d-flex align-items-center mt-2'>
          <div className='d-flex me-3'>
            <label
              className='font-12 poppins-medium title-color form-horztional'
              htmlFor='Inquiry Type'
            >
              Inquiry Type <span className='mandatory me-1'>*</span>
              <span
                className='tool-tip tooltip-bottom font-12 sourcesanspro'
                data-tip={tooltipObj.inquiryType?.TooltipDescription}
              >
                <span className='icon-info color-primary'></span>
              </span>
            </label>
          </div>
          <div className='d-flex align-items-center'>
            <InputCheckbox
              formClassName='d-flex align-items-center'
              inputProps={{
                arialabel: 'For Self',
                checked: inquiryForSelf,
                className: 'font-12 poppins-medium title-color mx-2',
                disabled: isInquiryEditing,
                id: 'ForSelf',
                label: 'For Self',
                name: 'InquiryType',
                type: 'radio',
                value: 'ForSelf',
              }}
              onChange={changeInquiryType}
            />
            <InputCheckbox
              formClassName='d-flex align-items-center'
              inputProps={{
                arialabel: 'For Other',
                checked: !inquiryForSelf,
                className: 'font-12 poppins-medium title-color mx-2',
                disabled: isInquiryEditing,
                id: 'ForOther',
                label: 'For Other',
                name: 'InquiryType',
                type: 'radio',
                value: 'ForOther',
              }}
              onChange={changeInquiryType}
            />
          </div>
        </div>
      </div>
      <div className='row align-items-end'>
        <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-3 mt-2'>
          <InputText
            changeHandler={(e: any) => handleChangeDoDNumber(e)}
            className='form-lg font-13 sourcesanspro'
            disabled={dodPopulated || isInquiryEditing || inquiryForSelf}
            formClassName=' form-vertical'
            info={
              !inquiryForSelf
                ? tooltipObj.dodNumber?.TooltipDescription
                : tooltipObj.profileDodNumber?.TooltipDescription
            }
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'DoDNumber',
              inputMode: 'numeric', // For numeric keyboards on mobile devices
              maxLength: MAX_LENGTHS.TEN_DIGITS,
              name: inquiryForSelf === 'ForOther' ? 'Customer DoD ID Number' : 'DOD ID Number',
              pattern: '[0-9]*', // Enforce numeric input
              placeholder:
                inquiryForSelf === 'ForOther' ? 'Customer DoD ID Number' : 'DOD ID Number',
              value: userInputs.DoDNumber,
            }}
            isInfo
            isMandatory
            label={!inquiryForSelf ? 'Customer DoD ID Number' : 'DOD ID Number'}
            ref={inputValidationObj.DoDNumber.link}
          />
        </div>

        <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-3 mt-2'>
          <InputText
            changeHandler={(e) => handleEmailChange(e)}
            className='form-lg font-13 sourcesanspro'
            data={peopleDropdownNames}
            disabled={dutyMailDisable || inquiryForSelf || isInquiryEditing}
            formClassName=' form-vertical'
            info={
              !inquiryForSelf
                ? tooltipObj.dutyEmail?.TooltipDescription
                : tooltipObj.profileDutyEmail?.TooltipDescription
            }
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-12 poppins-medium title-color mb-1',
              id: 'DutyEmail',
              maxLength: MAX_LENGTHS.TWO_HUNDRED_FIFTY,
              name: inquiryForSelf === 'ForOther' ? 'Customer Duty Email' : 'Duty Email',
              placeholder: inquiryForSelf === 'ForOther' ? 'Customer Duty Email' : 'Duty Email',
              value: userInputs.DutyEmail,
            }}
            isInfo
            isMandatory
            label={!inquiryForSelf ? 'Customer Duty Email' : 'Duty Email'}
            onSelect={(e) => selectedEmail(e, inquiryForSelf)}
            ref={inputValidationObj.DutyEmail.link}
            value={userInputs.DutyEmail}
          />
        </div>
        <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-3 mt-2'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical'
            id='AssignedComponent'
            info={
              !inquiryForSelf
                ? tooltipObj.assignedComp?.TooltipDescription
                : tooltipObj.profileAssignedComp?.TooltipDescription
            }
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label='Assigned Component'
            name='Assigned Component'
            onChange={handleAssignedComponentChange}
            options={assignedComponentOptions} // brought from db metadata
            ref={inputValidationObj.AssignedComponentCode.link}
            value={userInputs.AssignedComponentCode}
          />
        </div>

        <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-3 mt-2'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect'
            formClassName='form-vertical'
            id='ProfileStatus'
            info={
              !inquiryForSelf
                ? tooltipObj.status?.TooltipDescription
                : tooltipObj.profileStatus?.TooltipDescription
            }
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label={!inquiryForSelf ? 'Customer Status' : 'Status'}
            name={!inquiryForSelf ? 'Customer Status' : 'Status'}
            onChange={handleUserStatusChange}
            options={statusOptions}
            ref={inputValidationObj.CustomerStatus.link}
            value={userInputs.CustomerStatus}
          />
        </div>

        <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-3 mt-2'>
          <CustomSelect
            className='form-lg w-100 sourcesanspro font-13 customselect '
            formClassName='form-vertical text-nowrap'
            id='ProfileRank'
            info={
              !inquiryForSelf
                ? tooltipObj.rank?.TooltipDescription
                : tooltipObj.profileRank?.TooltipDescription
            }
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'mb-1 font-12 poppins-medium title-color',
            }}
            isInfo
            isMandatory
            label={!inquiryForSelf ? 'Customer Rank' : 'Rank'}
            name={!inquiryForSelf ? 'Customer Rank' : 'Rank'}
            onChange={handleRankChange}
            options={rankOptions}
            ref={inputValidationObj.Rank.link}
            value={userInputs.Rank}
          />
        </div>
        <div className='mb-1 col-12 col-sm-6 col-lg-4 col-xxl-3 mt-2'>
          <InputText
            changeHandler={(e: any) => handleChangeNumber(e)}
            className='form-lg font-13 sourcesanspro'
            formClassName=' form-vertical font-12 poppins-medium'
            info={
              !inquiryForSelf
                ? tooltipObj.dutyPhone?.TooltipDescription
                : tooltipObj.profileDutyPhone?.TooltipDescription
            }
            infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
            infoIcon='icon-info color-primary'
            inputProps={{
              className: 'font-13 poppins-medium title-color',
              id: 'DutyPhone',
              maxLength: MAX_LENGTHS.TEN_DIGITS,
              name: !inquiryForSelf ? 'Customer Duty Phone' : 'Duty Phone',
              placeholder: !inquiryForSelf ? '(123) 213-1231' : '(123) 213-1231',
              value: formatPhoneNumber(userInputs.DutyPhone),
            }}
            isInfo
            isMandatory
            label={!inquiryForSelf ? 'Customer Duty Phone' : 'Duty Phone'}
            ref={inputValidationObj.DutyPhone.link}
          />
        </div>
      </div>

      <ProfileOrganizationDetails
        assignedComponentCode={userInputs?.AssignedComponentCode}
        assignedLocationDDL={assignedLocationDDL}
        existingUser={existingUser}
        inputValidationObj={inputValidationObj}
        inquiryForSelf={inquiryForSelf}
        isProfilePage={false}
        isRegAF={isRegAF}
        majcoms={majcoms}
        organizationDDL={organizationDDL}
        organizationPASCODE={organizationPASCODE}
        pascodeChecks={pascodeChecks}
        pascodeDDL={pascodeDDL}
        pascodeMetadata={pascodeMetadata}
        setOrganizationDDL={setOrganizationDDL}
        setPascodeChecks={setPascodeChecks}
        setShowReadonlyInput={setShowReadonlyInput}
        setUserInputs={setUserInputs}
        showReadonlyInput={showReadonlyInput}
        userInputs={userInputs}
      />
    </>
  )
}
export default CustomerDetails
